import script from "./ImageCropperModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropperModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropperModal.vue?vue&type=style&index=0&id=6ddb3c7c&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddb3c7c"]])

export default __exports__